<template>
<div id="app">
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <router-link to = "/" tag="button">
    <v-btn
            class="ma-2"
            large
            dark
            >User Login
            <v-icon dark class="ml-3"> mdi-account </v-icon>
    </v-btn>
    </router-link>
    </v-app-bar>
    <v-main>
      <v-container class="my-5">
        <!-- Welcome Section -->
        <v-card class="mb-6" elevation="3">
          <v-card-title class="text-h4 justify-center primary white--text">
            Welcome!
          </v-card-title>
          <v-card-text class="text-h6 pa-6">
            <p class="mb-3">Thank you for helping with our graph research project!</p>
            <p class="mb-0">You will look at graphs and answer simple questions about them. Please read the instructions below.</p>
          </v-card-text>
        </v-card>

        <!-- Shortest Path Definition -->
        <v-card class="mb-6" elevation="3">
          <v-card-title class="text-h5 primary white--text">
            <v-icon color="white" class="mr-2">mdi-information</v-icon>
            What is the Shortest Path?
          </v-card-title>
          <v-card-text class="pa-6">
            <p class="text-h6 mb-4">
              The <strong>shortest path</strong> is the minimum number of edges (lines) you need to cross to get from one node (circle) to another.
            </p>
            <p class="text-body-1">
              Simply count the edges along the shortest route between two nodes.
            </p>
          </v-card-text>
        </v-card>

        <!-- Example -->
        <v-card class="mb-6" elevation="3">
          <v-card-title class="text-h5 success white--text">
            <v-icon color="white" class="mr-2">mdi-eye</v-icon>
            Example
          </v-card-title>
          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12" md="6">
                <v-card class="mx-auto" max-width="400">
                  <v-img 
                    :src="exampleGraphUrl"
                    aspect-ratio="1.5"
                    class="grey lighten-2"
                    contain
                    height="300"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center">
                <div>
                  <p class="text-h6 mb-4">
                    In this graph, the shortest path between the two highlighted nodes is <strong class="text-h4 success--text">2 edges</strong>.
                  </p>
                  <p class="text-h6 mb-3">
                    👉 So you should click <strong>Button 2</strong>
                  </p>
                  <v-chip x-large color="success" class="mb-3" dark>
                    <v-icon left>mdi-check-circle</v-icon>
                    2
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Not Sure Button -->
        <v-card class="mb-6" elevation="3">
          <v-card-title class="text-h5 warning white--text">
            <v-icon color="white" class="mr-2">mdi-help-circle</v-icon>
            "Not Sure" Button
          </v-card-title>
          <v-card-text class="pa-6">
            <v-row align="center">
              <v-col cols="12" md="8">
                <p class="text-h6 mb-3">
                  Click <strong>"Not Sure"</strong> when you don't know the answer or can't figure it out.
                </p>
                <p class="text-body-1">
                  It's okay to be unsure! Just click this button instead of guessing.
                </p>
              </v-col>
              <v-col cols="12" md="4" class="text-center">
                <v-btn x-large outlined color="warning" disabled>
                  <v-icon left>mdi-help-circle</v-icon>
                  Not Sure
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Quit Button -->
        <v-card class="mb-6" elevation="3">
          <v-card-title class="text-h5 error white--text">
            <v-icon color="white" class="mr-2">mdi-exit-to-app</v-icon>
            "Quit" Button
          </v-card-title>
          <v-card-text class="pa-6">
            <v-row align="center">
              <v-col cols="12" md="8">
                <p class="text-h6 mb-3">
                  The <strong>"Quit"</strong> button is in the top-right corner.
                </p>
                <p class="text-body-1 mb-2">
                  Click it anytime to stop and return to the home page. Your work is saved automatically!
                </p>
                <p class="text-body-1">
                  You can take breaks whenever you want.
                </p>
              </v-col>
              <v-col cols="12" md="4" class="text-center">
                <v-btn x-large color="error" disabled>
                  <v-icon left>mdi-exit-to-app</v-icon>
                  Quit
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Ready to Start -->
        <v-card class="mb-6" elevation="5">
          <v-card-title class="text-h5 justify-center primary white--text">
            Ready to Start?
          </v-card-title>
          <v-card-text class="text-center pa-6">
            <p class="text-h6 mb-4">
              Click "User Login" above to begin!
            </p>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</div>
</template>

<script>
export default {
  name:'Instruction',
  title: 'User Instruction',
  data () {
    return {
      exampleGraphUrl: require('@/assets/instruction.png')
    }
  },
}
</script>

<style scoped>
.v-card__title {
  word-break: normal;
}
</style>
